import React from "react";

import { Container } from "./styles";

const Select = React.forwardRef(
  ({ children, label, id, value, handler, mensagemErro }, ref) => (
    <Container>
      <label>{label}</label>
      <select id={id} value={value} onChange={handler} ref={ref}>
        {children}
      </select>
      <span>{mensagemErro}</span>
    </Container>
  )
);

export default Select;
